export default __webpack_public_path__ + "static/media/foam3.c85268c4.jpg";